import api from "../Axios";
//获取客户标签
export const apiGetCustomerLabel = () => api.get("/customer-tag");
//获取车辆标签
export const apiGetCarLabel = () => api.get(`/car-tag`);
//获取客户标签图表数据
export const apiGetCustomerChart = (EnName) => api.get(`/customer-tag/chart/${EnName}`);
//获取车辆标签图表数据
export const apiGetCarChart = (EnName) => api.get(`/car-tag/chart/${EnName}`);
